import { useField } from "formik";

import {
  InputWrapper,
  InputWrapperProps,
} from "../components/inputs/_assets/input-wrapper/InputWrapper";
import {
  TextArea,
  TextAreaProps,
} from "../components/inputs/text-area/TextArea";
import { CascadiaColor } from "packages/cascadia-tokens";

interface Props
  extends InputWrapperProps,
    Omit<TextAreaProps, "errorMessage" | "validationState" | "value"> {
  name: string;
  label?: string;
  info?: React.ReactNode;
  testID: string;
  minHeight?: number | string;
  backgroundColor?: CascadiaColor;
}

export function TextAreaFormikField(props: Props) {
  const [field, meta, helpers] = useField(props.name);
  const { span = "auto", ...textAreaProps } = props;

  return (
    <InputWrapper span={span}>
      <TextArea
        value={field.value}
        isInvalid={Boolean(meta.touched && meta.error)}
        errors={meta.touched ? meta.error : undefined}
        {...textAreaProps}
        onChange={(value) => {
          helpers.setValue(value);
          props.onChange?.(value);
        }}
        backgroundColor={props.backgroundColor}
      />
    </InputWrapper>
  );
}
